import React from "react";
import styled from "styled-components";
import image1 from "../assets/ourport.jpg";
import image2 from "../assets/Untitled design (22) 1.png";
import image3 from "../assets/CD Game Portfolio (22) 1.png";
import image4 from "../assets/scroll-down-unscreen 1.png";
import image5 from "../assets/GAMES PORTFOLIO.png";
import image16 from "../assets/APP PORTFOLIO.png";
import image17 from "../assets/WEB PORTFOLIO.png";
import image6 from "../assets/512 1.png";
import image7 from "../assets/5 13.png";
import image8 from "../assets/11 1.png";
import image9 from "../assets/icon 2 1.png";
import image10 from "../assets/icon 2 2 (1).png";
import image11 from "../assets/icon2 1.png";
import image12 from "../assets/icon 2qq 1.png";
import image13 from "../assets/Icon 1 1.png";
import image15 from "../assets/Icon1 1.png";
import image14 from "../assets/Untitled design (27) 1.png";
import rightIcon from "../assets/Untitled design (27) 1.png";
import textImage from "../assets/CD Game Portfolio (21) 1.png";
import { FaRegArrowAltCircleRight } from "react-icons/fa";
import { Link } from "react-router-dom";
const ArrowCont = styled(FaRegArrowAltCircleRight)`
  width: 24px;
  height: 24px;
  color: #000000;
  border-radius: 50%;
  padding: 2px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);

  @media (max-width: 1400px) {
    width: 16px;
    height: 16px;
    padding: 1.8px;
  }

  @media (max-width: 1024px) {
    width: 14px;
    height: 14px;
    padding: 1.5px;
  }

  @media (max-width: 768px) {
    width: 12px;
    height: 12px;
    padding: 1.2px;
  }

  @media (max-width: 480px) {
    width: 10px;
    height: 10px;
    padding: 1px;
  }
`;

const MainContanier = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* padding: 20px; */
`;

const PortfolioImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 600px; Adjust the max-width as needed */
  /* border-radius: 10px; */
`;

const ImageContanier = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  max-width: 80%;
  /* background-color: red; */
  margin-top: 20px;
  background-image: url(${textImage});
  background-size: cover;
  background-position: center;
  padding: 50px;

  @media (max-width: 1400px) {
    max-width: 90%;
    padding: 40px;
  }

  @media (max-width: 1024px) {
    max-width: 95%;
    padding: 30px;
    flex-direction: row;
    align-items: center;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 20px;
    flex-direction: row;
    align-items: center;
    background-size: contain;
  }

  @media (max-width: 480px) {
    flex-direction: row;
    padding: 15px;
    background-size: contain;
  }
`;

const Contanier1 = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  gap: 20px;
  /* background-color: green; */
`;

const Contanier4 = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  gap: 20px;
  /* background-color: green; */
`;

const Contanier2 = styled.div`
  width: 28%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* background-color: yellow; */
`;

const Contanier3 = styled.div`
  width: 28%;
  display: flex;
  flex-direction: column;

  gap: 10px;
  /* background-color: #ff00ea; */
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* background-color: darkblue; */

  /* margin-top: 20px; */
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  /* border-radius: 10px; */
`;

const TextWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #2cbbd4;
  background-image: url(image3);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 10px;
  border-radius: 30px;
  padding-top: 20px;

  @media (max-width: 1400px) {
    /* flex-direction: column; Column layout for smaller screens */
    text-align: center; /* Center text */
    padding: 15px;
  }

  @media (max-width: 1024px) {
    padding: 12px;
    border-radius: 20px;
  }

  @media (max-width: 768px) {
    padding: 10px;
    border-radius: 15px;
    background-size: cover; /* Adjust background image */
  }

  @media (max-width: 480px) {
    padding: 8px;
    border-radius: 10px;
  }
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: bold;
`;

const SeeMore = styled.div`
  font-size: 1.2vw; /* Responsive font size */
  color: #000000;
  font-weight: bold;
  cursor: pointer;

  @media (max-width: 1400px) {
    font-size: 8px;
  }

  @media (max-width: 1024px) {
    font-size: 7px;
  }

  @media (max-width: 768px) {
    font-size: 6px;
  }

  @media (max-width: 480px) {
    font-size: 5px;
  }
`;

const GameNameWrapper = styled.div`
  width: 100px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const GameName = styled.div`
  font-size: 14px;
`;

const RightIcon = styled.img`
  width: 80px;
  height: 80px;
  @media (max-width: 1400px) {
    max-width: 40px;
    max-height: 40px;
  }

  @media (max-width: 1024px) {
    max-width: 30px;
    max-height: 30px;
  }

  @media (max-width: 768px) {
    max-width: 20px;
    max-height: 20px;
  }

  @media (max-width: 480px) {
    max-width: 15px;
    max-height: 15px;
  }
`;
const TextImage = styled.img`
  max-width: 590px; /* Maximum width set ki gayi hai */
  width: 100%; /* Responsive width */
  height: auto;
  padding-left: 30px;
  margin-left: 20px;
  /* background-color: red; */

  @media (max-width: 1400px) {
    max-width: 400px; /* Tablets ke liye size reduce */
    padding-left: 20px;
    margin-left: 15px;
  }

  @media (max-width: 1024px) {
    max-width: 250px; /* Tablets ke liye size reduce */
    padding-left: 5px;
    margin-left: 5px;
  }

  @media (max-width: 768px) {
    max-width: 180px; /* Small tablets ke liye aur chhota */
    padding-left: 0px;
    margin-left: 0px;
  }

  @media (max-width: 480px) {
    max-width: 100px; /* Mobile screens ke liye compact */
    padding-left: 0px;
    margin-left: 0px;
  }
`;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  /* background-color: red; */
`;

const ThisImage = styled.img`
  width: 65%;
  height: auto;
  position: relative;
  margin-right: 75px;
  /* border-radius: 10px; */

  @media (max-width: 1200px) {
    width: 60%;
    height: auto;
    margin-right: 50px;
  }

  @media (max-width: 768px) {
    width: 60%;
    height: auto;
    margin-right: 40px;
  }
  @media (max-width: 480px) {
    width: 60%;
    height: auto;
    margin-right: 25px;
  }
  @media (max-width: 320px) {
    width: 60%;
    height: auto;
    margin-right: 20px;
  }
`;
const ThisImage1 = styled.img`
  width: 65%;
  height: auto;
  margin-left: 80px;
  position: relative;
  /* margin-left: 55px; */
  /* border-radius: 10px; */
  @media (max-width: 1200px) {
    width: 60%;
    height: auto;
    margin-left: 50px;
  }
  @media (max-width: 768px) {
    width: 65%;
    height: auto;
    margin-left: 30px;
  }
  @media (max-width: 480px) {
    width: 65%;
    height: auto;
    margin-left: 20px;
  }
  @media (max-width: 320px) {
    width: 65%;
    height: auto;
    margin-left: 15px;
  }
`;
const IimagetextContanier = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 12%;
  position: absolute;
  background-color: #2cbbd4;
  height: auto;
  padding: 5px;
  margin-top: 120px;
  border-radius: 15px;
  margin-right: 79px;

  @media (max-width: 1400px) {
    width: 11%;
    margin-top: 90px;
    margin-right: 80px;
    padding: 6px;
  }

  @media (max-width: 1024px) {
    width: 11%;
    margin-right: 30px;
    margin-top: 50px;
    padding: 4px;
  }

  @media (max-width: 768px) {
    width: 11%;
    margin-right: 18px;
    margin-top: 30px;
    padding: 1px;
  }

  @media (max-width: 480px) {
    width: 9%;
    margin-right: 15px;
    margin-top: 15px;
    padding: 2px;
  }
`;

const IimagetextContanier1 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 12%;
  position: absolute;
  background-color: #2cbbd4;
  height: auto;
  padding: 5px;
  margin-top: 120px;
  border-radius: 15px;
  margin-left: 80px;

  @media (max-width: 1400px) {
    width: 11%;
    margin-top: 90px;
    margin-right: 80px;
    padding: 6px;
  }

  @media (max-width: 1024px) {
    width: 11%;
    margin-right: 30px;
    margin-top: 50px;
    padding: 4px;
  }

  @media (max-width: 768px) {
    width: 11%;
    margin-right: 18px;
    margin-top: 30px;
    padding: 1px;
  }

  @media (max-width: 480px) {
    width: 9%;
    margin-right: 40px;
    margin-top: 15px;
    padding: 2px;
  }
`;
const TextCont = styled.div`
  font-size: 14px;
  /* font-weight: bold; */
  @media (max-width: 1400px) {
    font-size: 9px;
  }

  @media (max-width: 1024px) {
    font-size: 8px;
  }

  @media (max-width: 768px) {
    font-size: 5px;
  }

  @media (max-width: 480px) {
    font-size: 4px;
  }
`;

const Portfolio = () => {
  return (
    <>
      <MainContanier>
        <PortfolioImage src={image1} alt="Portfolio Image" />
        <ImageContanier>
          <Contanier1>
            <ImageWrapper>
              <Image src={image2} alt="Game Image 1" />
            </ImageWrapper>
            <TextWrapper>
              <TextImage src={image5} alt="image not found" />
              <Link to="/gameportfolio">
                <Div>
                  <RightIcon src={image4} alt="Right Icon" />
                  <SeeMore>See more</SeeMore>
                </Div>
              </Link>
            </TextWrapper>
          </Contanier1>
          <Contanier2>
            <ImageWrapper>
              <ThisImage src={image6} alt="Game Image 4" />
              <IimagetextContanier>
                <TextCont>Game Ling</TextCont>
                <ArrowCont />
              </IimagetextContanier>
            </ImageWrapper>
            <ImageWrapper>
              <ThisImage src={image7} alt="Game Image 4" />
              <IimagetextContanier>
                <TextCont>Game Ling</TextCont>
                <ArrowCont />
              </IimagetextContanier>
            </ImageWrapper>
            <ImageWrapper>
              <ThisImage src={image8} alt="Game Image 4" />
              <IimagetextContanier>
                <TextCont>Game Ling</TextCont>
                <ArrowCont />
              </IimagetextContanier>
            </ImageWrapper>
          </Contanier2>
        </ImageContanier>

        <ImageContanier>
          <Contanier3>
            <ImageWrapper>
              <ThisImage1 src={image9} alt="Game Image 4" />
              <IimagetextContanier1>
                <TextCont>Game Ling</TextCont>
                <ArrowCont />
              </IimagetextContanier1>
            </ImageWrapper>
            <ImageWrapper>
              <ThisImage1 src={image10} alt="Game Image 4" />
              <IimagetextContanier1>
                <TextCont>Game Ling</TextCont>
                <ArrowCont />
              </IimagetextContanier1>
            </ImageWrapper>
            <ImageWrapper>
              <ThisImage1 src={image11} alt="Game Image 4" />
              <IimagetextContanier1>
                <TextCont>Game Ling</TextCont>
                <ArrowCont />
              </IimagetextContanier1>
            </ImageWrapper>
          </Contanier3>
          <Contanier4>
            <ImageWrapper>
              <Image src={image2} alt="Game Image 1" />
            </ImageWrapper>
            <TextWrapper>
              <TextImage src={image16} alt="image not found" />
              <Link to="/gameportfolio">
                <Div>
                  <RightIcon src={image4} alt="Right Icon" />
                  <SeeMore>See more</SeeMore>
                </Div>
              </Link>
            </TextWrapper>
          </Contanier4>
        </ImageContanier>

        <ImageContanier>
          <Contanier1>
            <ImageWrapper>
              <Image src={image2} alt="Game Image 1" />
            </ImageWrapper>
            <TextWrapper>
              <TextImage src={image17} alt="image not found" />
              <Link to="/gameportfolio">
                <Div>
                  <RightIcon src={image4} alt="Right Icon" />
                  <SeeMore>See more</SeeMore>
                </Div>
              </Link>
            </TextWrapper>
          </Contanier1>
          <Contanier2>
            <ImageWrapper>
              <ThisImage src={image12} alt="Game Image 4" />
              <IimagetextContanier>
                <TextCont>Game Ling</TextCont>
                <ArrowCont />
              </IimagetextContanier>
            </ImageWrapper>
            <ImageWrapper>
              <ThisImage src={image13} alt="Game Image 4" />
              <IimagetextContanier>
                <TextCont>Game Ling</TextCont>
                <ArrowCont />
              </IimagetextContanier>
            </ImageWrapper>
            <ImageWrapper>
              <ThisImage src={image15} alt="Game Image 4" />
              <IimagetextContanier>
                <TextCont>Game Ling</TextCont>
                <ArrowCont />
              </IimagetextContanier>
            </ImageWrapper>
          </Contanier2>
        </ImageContanier>
      </MainContanier>
    </>
  );
};

export default Portfolio;
